<template>
  <div>
    <breadcrumbs :home="vesselName + ': Reassign lot'"/>

      <v-card flat>
        <v-form v-model="valid" ref="form" :disabled="!edit">
          <v-container class="pt-6 px-6 purtrak-scrollable" fluid>

            <v-row dense>
              <v-col cols="6" sm="4" lg="3">
                <date-picker v-model="transaction.date" @change="refresh()"/>
              </v-col>
            </v-row>

            <v-row dense>
              <v-col cols="6" sm="3" lg="2">
                <v-text-field label="To lot" v-model="transaction.lot" outlined dense counter="20" :rules="[fieldRules.required,fieldRules.maxLength(20)]"/>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <v-text-field label="Comments" v-model="transaction.comments" outlined dense counter="255" :rules="[fieldRules.maxLength(255)]"/>
              </v-col>
            </v-row>
          </v-container>
        </v-form>

        <v-divider/>
        <v-card-actions class="px-6">
          <template v-if="transactionId && company.permissions.includes('production.write')">
            <v-switch :disabled="dirty"
                      v-model="edit" label="Edit" hide-details class="mt-0"/>
          </template>
          <v-spacer/>
          <v-btn :plain="edit" color="primary" @click="cancel">{{edit?'Cancel':'Done'}}</v-btn>
          <v-btn v-if="edit" color="primary" :loading="saving" @click="save">Save</v-btn>
        </v-card-actions>
      </v-card>

    <confirm-leave v-model="next"/>
  </div>

</template>

<script>
import {format} from 'date-fns'
import confirmLeave from '@/mixins/confirmLeave'

export default {
  name: 'ExciseVesselReassignLot',
  mixins: [confirmLeave],
	props: {
    vesselId: {type:String,required:false},
    transactionId: {type:String, required:false}
	},
	data() {
		return {
      edit: false,
      vesselName: '',
      valid:true,
      saving:false,
      transaction: {vesselId:this.vesselId, date: format(new Date(), 'yyyy-MM-dd HH:mm:ss'), lot:null, comments: ''},
      dirty: false
		}
  },
  computed: {
    company() {
      return this.$store.getters.company;
    },
  },
  watch: {
    transaction: {
      handler() {this.dirty = true;},
      immediate: true,
      deep: true
    }
  },
	async created() {
    if (this.transactionId) {
      const results = await this.$apiCall(`query ExciseVesselReassignLot($id:ID!) {
                                              exciseVesselReassignLot(id:$id) {
                                                  id,vesselId,date,lot,comments
                                                }
                                              }`,
                                          {id:this.transactionId});
      if (results.error) {
        this.$nextTick(() => this.dirty = false);
        this.$router.back();
        return;
      }
      this.transaction = results.data.exciseVesselReassignLot;
    }
    else
      this.edit = true;

    await this.refresh();
    this.$nextTick(() => this.dirty = false);
  },

	methods: {
    async refresh() {
      const results = await this.$apiCall(`query ExciseVesselReassignLot($id:ID!, $date:DateTime) {
                                                exciseVessel(id:$id) {
                                                  name
                                                  contents(date:$date) {lot}
                                                }
                                              }`,
                                          {id:this.transaction.vesselId || this.vesselId, date:this.transaction.date});
      if (!results.error) {
        this.vesselName = results.data.exciseVessel.name;
        this.transaction.lot = results.data.exciseVessel.contents.lot;
        this.$nextTick(() => {this.$refs.form.validate()});
      }
    },
    cancel() {
      this.$router.back();
    },
		async save() {
      if (this.valid) {
        this.saving = true;
        const results = await this.$apiCall(`mutation ExciseVesselReassignLot($input: ExciseVesselReassignLotInput!) {
                                                exciseVesselReassignLotCreate(input:$input) {id}
                                              }`,
                                            {input:this.transaction});
        this.saving = false;
        if (!results.error) {
          this.dirty = false;
          this.$router.back();
          this.$store.commit('setError', {type:'success',message:`${this.transactionId?'Updated':'Created'} reassign lot transaction for ${this.vesselName}`});
        }
      }
		}
	}
}
</script>